import { useState, useCallback } from 'react';
import { API_CONSTANTS, PAYMENT_EXPIRY_TIME } from '../../utils';
import { useHandleApiCall } from '../useHandleApiCall';
import { useSnackbar } from 'notistack';
import { useRetrieveUserPaymentMethods } from 'apps/t2c-fe/services/payment/retrieveUserPaymentMethods';

export const useAddPaymentMethod = () => {
  const { post } = useHandleApiCall();
  const [isOpen, setIsOpen] = useState(false);
  const [options, setOptions] = useState<{ clientSecret: string; paymentId: string } | null>(null);
  const { enqueueSnackbar } = useSnackbar();
  const { data: cards, isLoading: isFetchingData, refetch } = useRetrieveUserPaymentMethods();
  const { mutateAsync: createPaymentMutation, isLoading: createPaymentMutationIsLoading } = post(
    API_CONSTANTS.CREATE_PAYMENT_METHOD.Key,
    API_CONSTANTS.CREATE_PAYMENT_METHOD.path
  );

  const getPaymentId = useCallback(
    async () => {
      const data = await createPaymentMutation({
        amount: 0,
        currency: 'USD',
        session_expiry: PAYMENT_EXPIRY_TIME,
      });
      return { clientSecret: data.client_secret, paymentId: data.payment_id };
    },
    [createPaymentMutation]
  );

  const handleBuy = useCallback(async () => {
    try {
      setIsOpen(true);
      const { clientSecret, paymentId } = await getPaymentId();
      setOptions({ clientSecret, paymentId });
    } catch (err) {
      console.error(err);
      enqueueSnackbar('We hit a glitch in the matrix! Please try again.', { variant: 'error' });
    }
  }, [getPaymentId]);

  const handleSuccess = useCallback(() => {
    setIsOpen(false);
    setOptions(null);
    refetch();
  }, []);

  const handleCancel = useCallback(() => {
    setIsOpen(false);
    setOptions(null);
  }, []);

  return {
    cards,
    isFetchingData,
    refetch,
    isOpen,
    setIsOpen,
    options,
    createPaymentMutationIsLoading,
    handleBuy,
    handleSuccess,
    handleCancel,
  };
};
